import { isClassificationUnset } from './classification';

export const CLOSURE_ERROR = {
  MISSING_CLASSIFICATION: 'missingClassification',
  MISSING_NAME: 'missingName',
  DUPLICATE_NAME: 'duplicateName',
};

export const hasClosureName = (name) => Boolean(name?.trim());

export const normalizeClosureName = (name) => name?.trim().toLowerCase() ?? '';

export const getDuplicateNameError = (closures, index) => {
  const closure = closures[index];

  if (!closure) return null;

  const name = normalizeClosureName(closure.name);

  if (!name) return null;

  const firstOccurrenceIndex = closures.findIndex(
    (other) => normalizeClosureName(other.name) === name
  );

  if (firstOccurrenceIndex === index) return null;

  return CLOSURE_ERROR.DUPLICATE_NAME;
};

export const getClosureValidationError = (
  closure,
  { closures, index, checkDuplicate = false } = {}
) => {
  if (!closure) return null;

  if (checkDuplicate && closures && index != null) {
    const duplicateError = getDuplicateNameError(closures, index);
    if (duplicateError) return duplicateError;
  }

  if (closure.locked) return null;

  const hasName = hasClosureName(closure.name);
  const hasClassification = !isClassificationUnset(closure.classification);

  if (!hasName && !hasClassification) return null;

  if (hasName && !hasClassification) {
    return CLOSURE_ERROR.MISSING_CLASSIFICATION;
  }

  if (hasClassification && !hasName) {
    return CLOSURE_ERROR.MISSING_NAME;
  }

  return null;
};

export const validateClosures = (closures) => {
  const errors = {};

  closures.forEach((closure, index) => {
    const error = getClosureValidationError(closure, {
      closures,
      index,
      checkDuplicate: true,
    });
    if (error) errors[index] = error;
  });

  const validClosures = closures.filter((closure, index) => {
    if (errors[index]) return false;

    if (closure.locked) return true;

    const hasName = hasClosureName(closure.name);
    const hasClassification = !isClassificationUnset(closure.classification);

    if (!hasName && !hasClassification) return false;

    return hasName && hasClassification;
  });

  return {
    errors,
    validClosures,
    isValid: Object.keys(errors).length === 0,
  };
};
